<template>
    <modal ref="messagesModal" :xxl="true" id="messages_modal" :class="[mode + '_mode']">
        <template v-slot:title>
            {{ $t('message.messages_title') }}
        </template>
        <template v-slot:body>
            <div>
                <message-filter v-show="mode === 'all'" ref="filter" />
                <message-filter-result ref="result" />
                <div class="claims-container _claims-results" id="search_result" v-if="!loading && messages.length > 0">
                    <div class="load-more-container">
                        <button @click="loadMore" v-if="!isEmptyMessages && page <= messagesInfo.pagecnt"
                            class="samo-btn btn--wide btn--square v-m _btn-to-form _frmSearchSubmit btn btn-primary">
                            {{ $t('message.item.download') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <MessageInput :mode="mode" ref="input" />
        </template>
    </modal>
</template>

<script>
import MessageFilter from 'modules/messages/MessageFilter.vue'
import MessageFilterResult from 'modules/messages/MessageFilterResult.vue'
import MessageInput from 'modules/messages/MessageInput.vue'
import Modal from 'components/ui/Modal.vue'
import { mapState } from 'vuex'

export default {
    name: 'messageModal',
    components: { MessageFilter, MessageFilterResult, Modal, MessageInput },
    data() {
        return {
            mode: 'all'
        };
    },
    methods: {
        loadMore() {
            const params = {
                claim_id: this.claim,
                status: this.status,
                sort: this.sort,
                page_number: this.page
            };
            this.$store.dispatch('messages/loadMore', params).then(() => {
                this.page += 1;
            })
        },
        showMessages(reservation = null){
            this.$store.dispatch('messages/clearResult');
            this.mode = reservation ? 'reservation' : 'all';
            if(reservation){
                this.$refs.filter.claim = reservation.num;
                this.$refs.filter.search();
                this.$refs.input.messageClaim = reservation.num;
                this.$refs.input.messageHotel = reservation.hotel_id ?? 4105;
            }else{
                this.$refs.filter.reset();
            }
            this.$refs.messagesModal.open()
        }
    },
    computed: {
        ...mapState({
            messages: state => state.messages.messages,
            messagesInfo: state => state.messages.messagesInfo,
            loading: state => state.messages.loading,
            isEmptyMessages: state => state.messages.isEmptyMessages
        })
    }
}
</script>
<style>
#messages_modal .modal-footer{
    display: block !important;
    padding: 0 !important;
    
}
#messages_modal .modal-footer .message-input-container{
    margin: 0 !important;
}
</style>
